import { useLocation, useNavigate } from 'react-router-dom';
import { useRef, useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../../../../component/BreadCrumb';
import {
    CODE_GROUP_ID,
    COMMUNITY_NOTICE_ADD_PATH,
    COMMUNITY_NOTICE_DETAIL_PATH,
    PATH_DELIMITER,
    ROLE,
} from '../../../../constant/Constant';
import CodeUtil from '../../../../util/CodeUtil';
import NullCheckUtil from '../../../../util/NullCheckUtil';
import AuthenticationUtil from '../../../../util/AuthenticationUtil';
import SelectionBox from '../../../../component/SelectionBox';
import InputBox from '../../../../component/InputBox';
import RegistButtonBox from '../../../../component/buttons/RegistButtonBox';
import { actionSearch } from '../../../../module/body/community/notice/CommunityNoticeModule';
import { VIEW_COMMUNITY_NOTICE } from '../../../../constant/ViewConstant';
import SearchButtonBox from '../../../../component/buttons/SearchButtonBox';
import ModalRef from '../../../../component/ModalRef';
import PopupRef from '../../../../component/PopupRef';
import { defaultGridData, handleControl, initGrid } from '../../../../module/component/TableBoxModule';
import TableBox from '../../../../component/TableBox';
import { IconButton, Tooltip } from '@material-ui/core';
import { OpenDetailIcon } from '../../../../component/icon/GridIcons';
import PathUtil from '../../../../util/PathUtil';
import qs from 'qs';

const ConditionArea = ({ popupRef, modalRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const addPermission =
        NullCheckUtil.isNotEmpty(AuthenticationUtil.getUserRoleCd()) &&
        (AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN || AuthenticationUtil.getUserRoleCd() == ROLE.STAFF);
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [noticeTypeCd, setNoticeTypeCd] = useState('');
    const [params, setParams] = useState({});

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { gridData } = useSelector((state) => state.tableBoxState);

    // 최초 초기화 호출
    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.noticeTypeCd && setNoticeTypeCd(queryData.noticeTypeCd);
        queryData.postingTitleNm && setPostingTitleNm(queryData.postingTitleNm);

        onClickSearch({
            noticeTypeCd: queryData.noticeTypeCd,
            postingTitleNm: queryData.postingTitleNm,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 10,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClickSearch({ ...params, page, pageSize });
    };

    const onClickSearch = (inputParams) => {
        let params = { ...inputParams, showAll: addPermission };

        setParams(params);
        dispatch(
            actionSearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, params);
    };

    const onRowDoubleClick = (row, params) => {
        var path = COMMUNITY_NOTICE_DETAIL_PATH + PATH_DELIMITER + row.postingNo;
        navigate(path);
    };

    const handleAdd = () => {
        navigate(COMMUNITY_NOTICE_ADD_PATH);
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                noticeTypeCd,
                postingTitleNm,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'postingNo',
                headerName: '번호',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 3,
            },
            {
                field: 'postingTitleNm',
                headerName: '제목',
                headerAlign: 'center',
                align: 'left',
                tooltip: true,
                flex: 15,
                renderCell: (params) => (
                    <div>
                        {params.row.topDisplay == true && <span className='answer-mark blue'>{'중요'}</span>}
                        {params.row.postingTitleNm}
                    </div>
                ),
            },
            // {
            //     field: 'userUniversityCd',
            //     headerName: '공지작성대학',
            //     headerAlign: 'center',
            //     align: 'center',
            //     tooltip: true,
            //     flex: 5,
            //     renderCell: (params) => {
            //         params.row.userUniversityCd &&
            //             CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, params.row.userUniversityCd);
            //     },
            // },

            {
                field: 'userNm',
                headerName: '작성자',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 3,
            },
            {
                field: 'useStatusCd',
                headerName: '사용상태',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 3,
                renderCell: (params) =>
                    params.row.useStatusCd == 'ENABLED' ? (
                        <div>사용</div>
                    ) : (
                        <div style={{ color: '#FF6C6C' }}>미사용</div>
                    ),
            },
            {
                field: 'regDttm',
                headerName: '등록일',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 5,
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 2,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='상세'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenDetailIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <>
            <div className='con-form-wrap '>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='search-condition-box'>
                                <div className='form-box-container'>
                                    <SelectionBox
                                        title='구분'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.NOTICE_TYPE)}
                                        value={noticeTypeCd}
                                        onChange={(e) => setNoticeTypeCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <InputBox
                                        title='제목'
                                        value={postingTitleNm}
                                        onChange={(e) => setPostingTitleNm(e.target.value)}
                                        size='w-420'
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                </div>
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            noticeTypeCd,
                                            postingTitleNm,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>공지사항 목록</h3>
                    {addPermission && <RegistButtonBox title='등록' btnCommon onClick={(e) => handleAdd()} />}
                </div>
            </div>
        </>
    );
};

const CommunityNoticeView = () => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg02'>
                    {/* <h2 className='con-title'>공지사항</h2> */}
                    <h2 className='con-title'>{VIEW_COMMUNITY_NOTICE.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_NOTICE.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <ConditionArea popupRef={popupRef} modalRef={modalRef} />
                <TableBox isSupportedWide={false} />
            </div>
            <ModalRef ref={modalRef} />
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityNoticeView;
